<dx-popup
  contentTemplate="popup-content"
  [(visible)]="visible"
  [showTitle]="true"
  title="Resource Cost Override"
  position="center"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  [width]="600"
  [height]="500"
  [resizeEnabled]="false"
  [dragEnabled]="false"
  (onHidden)="onHidden()"
>
  <div *dxTemplate="let data of 'popup-content'">
    <dx-data-grid
      [dataSource]="resources"
      keyExpr="resourceId"
      [showBorders]="true"
      [showColumnLines]="true"
      [showRowLines]="true"
      [rowAlternationEnabled]="true"
    >
      <dxo-editing mode="cell" [allowUpdating]="true"></dxo-editing>

      <dxi-column
        dataField="fullName"
        caption="Name"
        [allowEditing]="false">
      </dxi-column>

      <dxi-column
        dataField="resourceRole"
        caption="Role"
        [allowEditing]="true">
      </dxi-column>

      <dxi-column
        dataField="realCost"
        caption="Real Cost"
        dataType="number"
        format="#,##0.00"
        [allowEditing]="true">
      </dxi-column>
    </dx-data-grid>
  </div>

  <dxi-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="closeBtnOpts">
  </dxi-toolbar-item>
  <dxi-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="saveBtnOpts">
  </dxi-toolbar-item>
</dx-popup>
